import React from "react";

import { ArrowLeft12Filled, InfoRegular } from "@fluentui/react-icons";
import { Button, mergeClasses, Text } from "@fluentui/react-components";

import { Stack } from "../stack";
import { usePlaybookViewerStyles } from "./styles";

import { PlaybookRuleCard } from "./components/playbook-rule-card";

import { Playbook } from "@/types/risk-analysis";

interface PlaybookViewerProps extends React.ComponentPropsWithoutRef<"div"> {
  playbook: Playbook;
  onGoBack: () => void;
}

export function PlaybookViewer({ playbook, className, onGoBack, ...props }: PlaybookViewerProps) {
  const styles = usePlaybookViewerStyles();
  return (
    <div className={mergeClasses(styles.container, className)} {...props}>
      <Button appearance="transparent" icon={<ArrowLeft12Filled />} onClick={onGoBack}>
        {playbook.name}
      </Button>
      {playbook.rules.length === 0 && (
        <Stack direction="column" align="center" justify="center" style={{ marginTop: "1rem" }}>
          <InfoRegular style={{ fontSize: "1.5rem" }} />
          <Text>No playbook rules found!</Text>
        </Stack>
      )}
      {playbook.rules.length > 0 && (
        <Stack direction="column" gap="1rem" className={styles.cards}>
          {playbook.rules.map((playbookRule) => (
            <PlaybookRuleCard key={playbookRule.id} playbookRule={playbookRule} />
          ))}
        </Stack>
      )}
    </div>
  );
}
